import React from 'react';
import ReactDOM from 'react-dom';
import HomePage from './pages/home';
import './assets/styles/index.scss';

ReactDOM.render(<HomePage />, document.getElementById('root'));
